import { formatAmount } from "helpers";

type FeeRow = [string, number];

const formatFeeRow = ([label, fee]: FeeRow, currency?: string) => {
  return [label, formatAmount(fee, currency, 2)];
};

export type { FeeRow };
export { formatFeeRow };
